import { useEffect } from 'react';
import { toast } from 'sonner';
import { RefreshCw } from 'lucide-react';

const SWUpdateNotifier = () => {
  useEffect(() => {
    const handler = (e) => {
      const reg = e.detail;
      toast(
        <div className="flex items-center gap-3" data-testid="sw-update-toast">
          <RefreshCw size={18} className="text-[#D4AF37] flex-shrink-0" />
          <div className="flex-1">
            <p className="font-semibold text-sm text-[#1A2B3C]">New version available</p>
            <p className="text-xs text-slate-500">Tap to refresh and get the latest features.</p>
          </div>
          <button
            data-testid="sw-update-refresh-btn"
            onClick={() => {
              if (reg?.waiting) {
                reg.waiting.postMessage({ type: 'SKIP_WAITING' });
              } else {
                window.location.reload();
              }
            }}
            className="px-3 py-1.5 bg-[#1A2B3C] text-white text-xs font-semibold rounded-lg hover:bg-[#2A3B4C] transition-colors"
          >
            Refresh
          </button>
        </div>,
        { duration: Infinity, id: 'sw-update' }
      );
    };

    window.addEventListener('sw-update-available', handler);
    return () => window.removeEventListener('sw-update-available', handler);
  }, []);

  return null;
};

export default SWUpdateNotifier;
